import BaseServiceCrud from './BaseServiceCrud';

export default class IssueService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'issue';
    }

    resolveEnumCriteria(value) {
        if (value == null || value === '') {
            return undefined;
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.enumValue;
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            status: this.resolveEnumCriteria(criteria.status),
            issue_type: this.resolveEnumCriteria(criteria.type),
            title: criteria.title,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    markResolved(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}/resolved`, {
            method: 'PATCH',
        }).then((res) => Promise.resolve(res));
    }

    markRejected(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}/rejected`, {
            method: 'PATCH',
        }).then((res) => Promise.resolve(res));
    }
}
